export default (dirty = "") => 
    // Remove HTML looking things.
    dirty.replace(/<[^>]+>/g, '')
    // These could all be smashed together into one replace, but this is more legible.
    .replace(/!?\[/g, '')
    .replace(/[|#=\-*_~`+[\]]/g, '')
    .replace(/\([^)]+\)/g, '')